import React from 'react';
import { array, func, string, bool } from 'prop-types';
import { size } from 'lodash';
import { Button, FlexContainer, FormSelect, Text } from '../../common';

const actionOptions = [
    { label: 'Reprogramar', value: 'modify_shipping' }
];

const Space = () => <div style={{ width: '17px' }} />;

const MassiveActions = ({ selectedOrders, action, setAction, setOpened, selectedSla }) => {
    const reprogrammingIsSelected = action.value === 'modify_shipping';
    const OrderIsSelected = !(size(selectedOrders) > 0);

    return (
        <FlexContainer align='center' pX={12}>
            <Text text='Acciones' semibold size={14} />
            <Space />
            <FormSelect options={actionOptions} onChange={({ value }) => setAction(value)} value={action} />
            {reprogrammingIsSelected && <>
                <Space />
                <Button
                    text='Ejecutar'
                    fitContent
                    onClick={() => size(selectedSla) > 1 && setOpened(true)}
                    disabled={OrderIsSelected}
                />
            </>}
        </FlexContainer>
    );
};

MassiveActions.propTypes = {
    selectedOrders: array,
    setAction: func,
    action: string,
    setOpened: bool,
    selectedSla: string
};

export default MassiveActions;
